import { api } from './api';

export interface TutorTopicContentDTO {
  nodeId: number;
  content: string;
  isInherited: boolean;
  hasCustomContent: boolean;
  blocks?: string | null;
  format?: string | null;
}

export async function getContent(courseId: number, nodeId: number): Promise<TutorTopicContentDTO> {
  const response = await api.get<{ data: TutorTopicContentDTO }>(
    `/api/tutor/courses/${courseId}/nodes/${nodeId}/content`
  );
  return response.data.data;
}

export async function getStudentContent(courseId: number, nodeId: number): Promise<TutorTopicContentDTO> {
  const response = await api.get<{ data: TutorTopicContentDTO }>(
    `/api/student/courses/${courseId}/nodes/${nodeId}/content`
  );
  return response.data.data;
}

export async function saveContent(
  courseId: number,
  nodeId: number,
  content: string
): Promise<TutorTopicContentDTO> {
  const response = await api.put<{ data: TutorTopicContentDTO }>(
    `/api/tutor/courses/${courseId}/nodes/${nodeId}/content`,
    { content }
  );
  return response.data.data;
}

export interface ContentPageDTO {
  id: number;
  position: number;
  blocksJson: string;
}

export async function getContentPages(
  courseId: number,
  nodeId: number
): Promise<ContentPageDTO[]> {
  const response = await api.get<{ data: ContentPageDTO[] }>(
    `/api/tutor/courses/${courseId}/nodes/${nodeId}/content/pages`
  );
  return response.data.data ?? [];
}

export async function addContentPage(
  courseId: number,
  nodeId: number,
  position: number,
  blocksJson: string
): Promise<ContentPageDTO> {
  const response = await api.post<{ data: ContentPageDTO }>(
    `/api/tutor/courses/${courseId}/nodes/${nodeId}/content/pages`,
    { position, blocksJson }
  );
  return response.data.data;
}

export async function updateContentPage(
  courseId: number,
  nodeId: number,
  pageId: number,
  position: number,
  blocksJson: string
): Promise<ContentPageDTO> {
  const response = await api.put<{ data: ContentPageDTO }>(
    `/api/tutor/courses/${courseId}/nodes/${nodeId}/content/pages/${pageId}`,
    { position, blocksJson }
  );
  return response.data.data;
}

export async function reorderContentPages(
  courseId: number,
  nodeId: number,
  pageIds: number[]
): Promise<ContentPageDTO[]> {
  const response = await api.put<{ data: ContentPageDTO[] }>(
    `/api/tutor/courses/${courseId}/nodes/${nodeId}/content/pages/order`,
    pageIds
  );
  return response.data.data;
}

export async function deleteContentPage(
  courseId: number,
  nodeId: number,
  pageId: number
): Promise<void> {
  await api.delete(`/api/tutor/courses/${courseId}/nodes/${nodeId}/content/pages/${pageId}`);
}

export async function generateAiDraft(
  courseId: number,
  nodeId: number
): Promise<{ nodeId: number; draftContent: string }> {
  const response = await api.post<{ data: { nodeId: number; draftContent: string } }>(
    `/api/tutor/courses/${courseId}/nodes/${nodeId}/content/ai-generate`
  );
  return response.data.data;
}
